<template>
    <div>
        <m-assembly-table ref='pageForm'
            thDrag
            :formData='formData'
            :columns='columnsFilter'
            :data='tableData'
            :tableButtons='tableButtons'
            :loading='loading'
            :currentPage='settings.currentPage'
            :pageSize='settings.pageSize'
            :total='settings.total'
            :settings='settings'
            @onSubmit='onSubmit'
            @onPageSizeChange='onPageSizeChange'
            @onCurrentPageChange='onPageChange'
            @onSelectionChange="onSelectionChange"
        >
        </m-assembly-table>

        <Modal :title="$t('fpzPay.t16')"
               :width="400"
               v-model="fpzPayModal.show">
               <Table border
                      size="small"
                      :columns="fpzPayModal.columns"
                      :data="fpzPayModal.tableData">
               </Table>
        </Modal>
    </div>
</template>
<script>
import axios from 'axios';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index';
import { getOuList, exportExcel2 } from './financialAccounting';
import moment from 'moment';

export default {
    name: 'fpzInvaccSearch',
    components: { 
        mAssemblyTable,
    },
    computed: {
        columnsFilter() {
            return this.tableData.length > 0 ? this.columns : { columns: this.columns.columns.filter((item) => !['payedDate', 'payedAmount'].includes(item.key)) };
        },
    },
    data() {
        return {
            formData: {
                row: 2,
                items: [
                    {
                        value: '',
                        field: 'orgId', // 买方
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            multiple: false,
                            values: [],
                        },
                        type: 'select',
                        title: this.$t('fpzPay.t1'),
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('common.not_empty_require'),
                            },
                        },
                    },
                    {
                        value: '',
                        field: 'payPlanNum', // 付款计划编号
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        options: {
                            rows: 1,
                            type: 'text',
                        },
                        type: 'text',
                        title: this.$t('fpzPay.t5'),
                    },
                    {
                        value: '',
                        field: 'payWay', // 付款方式
                        disabled: false,
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1,
                        },
                        methods: {},
                        options: {
                            multiple: false,
                            values: [],
                        },
                        filterable: true,
                        type: 'select',
                        title: this.$t('fpzPay.t3'),
                    },
                    {
                        value: '',
                        field: 'dueStartDate', // 发布日期
                        layout: {
                            row: 2,
                            span: 8,
                            offset: 0,
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 00:00:00',
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: this.$t('fpzPay.t4'),
                        placeholder: '',
                        isDouble: true,
                    },
                    {
                        hide: true,
                        value: '',
                        field: 'dueEndDate',
                        layout: {
                            span: 4,
                            offset: 0,
                            row: 2,
                        },
                        options: {
                            type: 'date',
                            format: 'yyyy-MM-dd 23:59:59',
                            options: {
                                disabledDate(date) {
                                },
                            },
                        },
                        style: 'width:100%',
                        type: 'datePicker',
                        title: '',
                    },
                ],
            },
            columns: {
                columns: [
                    {
                        title: this.$t('fpzPay.t5'), // 付款计划编号
                        key: 'payPlanNum',
                        minWidth: 145,
                        tooltip: true,
                    },
                    {
                        title: this.$t('fpzPay.t19'), // 付款计划类型,
                        key: 'payPlanType',
                        minWidth: 100,
                    },
                    {
                        title: this.$t('fpzPay.t4'), // 排款日期
                        key: 'dueDate',
                        minWidth: 110,
                        render: (h, params) => {
                            const { dueDate } = params.row;
                            return h('span', (dueDate && moment(dueDate).format('YYYY-MM-DD')) || '');
                        },
                    },
                    {
                        title: this.$t('fpzPay.t6'), // 未到期金额
                        key: 'liabilityUnDue',
                        align: 'right',
                        minWidth: 60,
                    },
                    {
                        title: this.$t('fpzPay.t7'), // 到期可付款
                        key: 'dueAllowedPayable',
                        align: 'right',
                        minWidth: 60,
                    },
                    {
                        title: this.$t('fpzPay.t8'), // 申请支付金额
                        key: 'applyPay',
                        align: 'right',
                        minWidth: 60,
                    },
                    {
                        title: this.$t('fpzPay.t20'), // 预扣税金额
                        key: 'whtAmount',
                        align: 'right',
                        minWidth: 60,
                    },
                    {
                        title: this.$t('fpzPay.t21'), // 实际申请支付金额
                        key: 'actualApplyPay',
                        align: 'right',
                        minWidth: 60,
                    },
                    {
                        title: this.$t('fpzPay.t9'), // 付款状态
                        key: 'status',
                        minWidth: 80,
                    },
                    {
                        title: this.$t('fpzPay.t10'), // 说明
                        key: 'description',
                        minWidth: 150,
                        tooltip: true,
                    },
                    {
                        title: this.$t('fpzPay.t11'), // 币种
                        key: 'currencyCode',
                        minWidth: 60,
                    },
                    {
                        title: this.$t('fpzPay.t3'), // 付款方式
                        key: 'payWay',
                        minWidth: 60,
                    },
                    // {
                    //     title: this.$t('fpzPay.t12'), // 实际支付金额
                    //     key: 'payedAmount',
                    //     align: 'right',
                    //     minWidth: 60,
                    // },
                    {
                        title: this.$t('fpzPay.t13'), // 银行账号
                        key: 'bankAccountNo',
                        minWidth: 130,
                        tooltip: true,
                    },
                    {
                        title: this.$t('fpzPay.t14'), // 银行账户名称
                        key: 'bankAccountName',
                        minWidth: 110,
                        tooltip: true,
                    },
                    {
                        title: this.$t('fpzPay.t15'), // 开户行
                        key: 'bankName',
                        minWidth: 110,
                        tooltip: true,
                    },
                    {
                        title: this.$t('fpzPay.t17'), // 付款日期
                        key: 'payedDate',
                        minWidth: 100,
                    },
                    {
                        title: this.$t('fpzPay.t18'), // 付款金额
                        key: 'payedAmount',
                        minWidth: 60,
                        align: 'right',
                    },
                    // {
                    //     title: this.$t('fpzPay.t16'), // 实际付款详细
                    //     key: 'details',
                    //     align: 'center',
                    //     width: 40,
                    //     fixed: 'right',
                    //     render: (h, params) => {
                    //         return h('Button', {
                    //             props: {
                    //                 type: 'text',
                    //                 icon: 'ios-list-outline',
                    //                 size: 'small',
                    //             },
                    //             style: {
                    //                 fontSize: '16px',
                    //             },
                    //             on: {
                    //                 click: () => {
                    //                     this.fpzPayModal.show = true;
                    //                     this.fpzPayModal.tableData = [params.row];
                    //                 },
                    //             },
                    //         });
                    //     },
                    // },
                ],
            },
            tableData: [],
            tableButtons: {
                customButtons: [
                    {
                        label: this.$t('fpzInvaccSearch.t27'),
                        type: 'primary',
                        icon: 'archive',
                        loading: false,
                        disabled: false,
                        size: 'small',
                        click: (button) => {
                            if (this.$refs.pageForm.$children[0].$children[0].validateForm()) {
                                this.$set(button, 'loading', true);
                                exportExcel2('/gscint/payPlan/export', {
                                    ...this.getFormDataVModel(this.formData.items),
                                    vendorCode: this.vendorCode,
                                    language: this.switchLanguage(this.$i18n.locale),
                                }, `${this.$t('fpzPay.t22')} ${moment().format('YYYY-MM-DD')}.xls`, this)
                                    .finally(() => {
                                        this.$set(button, 'loading', false);
                                    });
                            }
                        },
                    },
                ],
            },
            loading: false,
            settings: {
                needPager: true,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [10, 20, 50, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 10,
                total: null,
                submitLoading: false,
            },
            INT_PAY_WAY_CODE: [],
            fpzPayModal: {
                show: false,
                columns: [
                    {
                        title: this.$t('fpzPay.t17'), // 付款日期
                        key: 'payedDate',
                    },
                    {
                        title: this.$t('fpzPay.t18'), // 付款金额
                        key: 'payedAmount',
                    },
                ],
                tableData: [],
            },
        };
    },
    methods: {
        onSubmit(currentPage, pageSize) {
            this.settings.currentPage = currentPage;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageSizeChange(currentPage, pageSize) {
            this.settings.currentPage = 1;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onPageChange(currentPage) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        onSearch() {
            this.loading = true;
            axios.post('/gscint/payPlan/query', {
                ...this.getFormDataVModel(this.formData.items),
                vendorCode: this.vendorCode,
                pageIndex: this.settings.currentPage,
                pageSize: this.settings.pageSize,
                language: this.switchLanguage(this.$i18n.locale),
            })
                .then(res => {
                    this.loading = false;
                    const { list, total } = res.data.data.datas;
                    this.tableData = list;
                    this.settings.total = total;
                })
                .catch(() => {
                    this.showErrorTips();
                });
        },
    },
    mounted() {
        const formItems = this.formData.items;
        getOuList((data) => {
            this.getFormDataItemObj(formItems, 'orgId').options.values = data;
        });
        this.getDict('INT_PAY_WAY_CODE', (data) => {
            this.getFormDataItemObj(formItems, 'payWay').options.values = data;
        });
    },
};

</script>
